import React, { useState, useEffect, useRef } from "react";
import "./fbxyearPicker.style.scss"; // CSS for styling
import { getEasternDateParts } from "../../../utils/dateUtils.ts";

const FBXYearPicker = ({
    minYear = 1997,
    maxYear = 2000,
    selectedYear = null,
    onYearChange,
    placeholder = "Select a year",
    style,
    isOpen = false,
    onTogglePicker,
    fieldName,
}) => {
    // State
    const [possibleYears, setPossibleYears] = useState([]);
    const currentYear = Number(getEasternDateParts().year); // Get the current year in Eastern time
    const displayedYear = selectedYear || currentYear; // Use currentYear if selectedYear is null
    const currentYearRef = useRef(null); // Ref for the year to scroll to

    // Generate possible years within range
    useEffect(() => {
        const parsedMinYear = parseInt(minYear, 10);
        const parsedMaxYear = parseInt(maxYear, 10);

        const years = Array.from(
            { length: parsedMaxYear - parsedMinYear + 1 },
            (_, i) => parsedMinYear + i
        );
        setPossibleYears(years);
    }, [minYear, maxYear]);

    // Scroll the appropriate year into view when the picker opens
    useEffect(() => {
        if (isOpen && currentYearRef.current) {
            currentYearRef.current.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });

            // ✅ FIX: removing body overflow changes to prevent page "stretch"/reflow
            // document.body.style.overflow = "hidden";
        } else {
            // document.body.style.overflow = "auto";
        }
    }, [isOpen]);

    // Handle year selection
    const selectYear = (year) => {
        onYearChange(fieldName, year);
    };

    // Reset the selected year
    const resetYear = () => {
        onYearChange(fieldName, null); // Notify parent component
    };

    // Keep your existing style, but ensure we can anchor an absolute popup without layout changes
    const containerStyle =
        style && style.position
            ? style
            : { ...(style || {}), position: "relative" };

    return (
        <div className="col-48" style={containerStyle}>
            <div
                className="d-flex"
                onClick={() => onTogglePicker(!isOpen)}
            >
                <input
                    type="text"
                    value={selectedYear || ""}
                    placeholder={placeholder}
                    readOnly
                    style={{
                        backgroundColor: selectedYear ? "black" : "white",
                        color: selectedYear ? "yellow" : "black",
                        borderRadius: "4px 0px 0px 4px",
                        borderRight: "none",
                    }}
                    className="fbx-calendar-input-field"
                />
                <button
                    className="fbx-reset-button"
                    onClick={(e) => {
                        e.stopPropagation(); // Prevent toggling picker
                        resetYear();
                    }}
                    disabled={!selectedYear} // Disable if no year is selected
                    style={{
                        width: "35px",
                        height: "35px",
                        backgroundColor: selectedYear ? "black" : "white",
                        color: selectedYear ? "yellow" : "transparent",
                        border: "1px solid #ced4da",
                        borderLeft: "none",
                        borderRadius: "0px 4px 4px 0px",
                        cursor: selectedYear ? "pointer" : "not-allowed",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    X
                </button>
            </div>

            {isOpen && (
                <div
                    style={{
                        // ✅ FIX: absolute so it overlays and does NOT expand/push layout
                        position: "absolute",
                        background: "var(--lightish)",
                        border: "2px solid navy",
                        width: "300px",
                        padding: "3px",
                        top: "26px",
                        left: "-8px",
                        borderRadius: "6px",
                        zIndex: 500,
                        maxHeight: "325px",
                        overflowY: "scroll",
                        /* Add shadow */
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                        transform: "scale(0.95)",
                        transition: "opacity 0.3s ease, transform 0.3s ease",
                    }}
                >
                    <div className="fbx-year-grid">
                        {possibleYears.map((year) => (
                            <button
                                key={year}
                                ref={year === displayedYear ? currentYearRef : null}
                                className={`btn ${year === currentYear
                                    ? "btn-primary opacity-50"
                                    : year === selectedYear
                                        ? "btn-selected"
                                        : "btn-white"
                                    }`}
                                onClick={() => selectYear(year)}
                            >
                                {year}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default FBXYearPicker;
